export default __webpack_public_path__ + "static/media/EX-011.65a83d64.png";